import { FilterTemplateRequest, FilterTemplateSelectedFilter } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { SelectedFilters } from '../../types/filters.type';
import { AdapterInterface } from '../../types/global';

import BaseAdapter from './baseAdapter';

export default class PostFilterTemplateValues extends BaseAdapter<{ [title: string]: { [key: string]: FilterTemplateSelectedFilter } }> implements AdapterInterface {
  rawResponse: { [title: string]: { [key: string]: FilterTemplateSelectedFilter } };

  modifiedRequest: FilterTemplateRequest;

  async adaptResponse(request: string): Promise<SelectedFilters> {
    const formattedRequest = this.adaptRequest(request);
    await this.fetchApiResponse('/api/filter-template-values', HTTPMethod.Post, formattedRequest);
    return this.rawResponse;
  }

  adaptRequest(request: string): FilterTemplateRequest {
    this.modifiedRequest = { template_id: Number(request) };
    return this.modifiedRequest;
  }
}
